// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z9Vh","right":"styles_right__EHDmJ"};